import { type FormEvent } from 'react';
import OtpConfettiImage from '@assets/images/otp-confetti.png';
import OtpStatueImage from '@assets/images/otp-statue.png';

import { InputOTP, InputOTPGroup, InputOTPSlot } from '@ui/input-otp';

import styles from './otp.module.css';

type OtpProps = {
  code: string;
  codeLength: number;
  error: string;
  isResendDisabled: boolean;
  resendDelay: number;
  onCodeChange: (value: string) => void;
  onResend: () => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => Promise<void>;
};

export const Otp = ({
  code,
  codeLength,
  error,
  isResendDisabled,
  resendDelay,
  onCodeChange,
  onResend,
  onSubmit,
}: OtpProps) => {
  const resendLabel =
    resendDelay > 0
      ? `Resend code in ${resendDelay}s`
      : "Didn't receive a code?";
  const slots = Array.from({ length: codeLength }, (_, index) => ({
    value: code[index],
    isActive:
      index === code.length ||
      (code.length === codeLength && index === code.length - 1),
  }));

  return (
    <div className={styles.otpLayout}>
      <img className={styles.otpImage} src={OtpStatueImage} alt="" />
      <form className={styles.otpForm} onSubmit={onSubmit}>
        <div className={styles.otpHeader}>
          <div className={styles.otpTitleRow}>
            <h1 className={styles.otpTitle}>
              We sent you
              <br />a code
            </h1>
            <img
              className={styles.otpConfetti}
              src={OtpConfettiImage}
              alt=""
              aria-hidden
            />
          </div>
          <p className={styles.otpSubtitle}>
            Check your email to get verify coded
          </p>
        </div>
        <label className={styles.otpCodeField}>
          <InputOTP
            aria-label="Verification code"
            name="userInputCode"
            containerClassName={styles.otpInputContainer}
            value={code}
            onChange={onCodeChange}
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={codeLength}
          >
            <InputOTPGroup className={styles.otpInputGroup}>
              {slots.map((slot, index) => (
                <InputOTPSlot
                  className={styles.otpInputSlot}
                  key={index}
                  index={index}
                  value={slot.value}
                  isActive={slot.isActive}
                />
              ))}
            </InputOTPGroup>
          </InputOTP>
        </label>
        {error && <p className={styles.error}>{error}</p>}
        <button
          className={styles.otpResend}
          type="button"
          onClick={isResendDisabled ? undefined : onResend}
          disabled={isResendDisabled}
        >
          {resendLabel}
        </button>
      </form>
    </div>
  );
};
